module.exports = __webpack_public_path__ + "f31a0deed9d8964dc977e10195d5ca81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/box.png
// module id = 1639
// module chunks = 5